import { devtools } from 'zustand/middleware';

import { create } from '@app/store/zustand/helpers/create';

export enum DiscoverSectionTab {
    Fresh = 'fresh',
    Recent = 'Recent',
    Top = 'top',
}

interface FantasyDiscoverSectionTabState {
    discoverSectionTab: DiscoverSectionTab;
}

interface FantasyDiscoverSectionTab extends FantasyDiscoverSectionTabState {
    setDiscoverSectionTab: (discoverSectionTab: DiscoverSectionTab) => void;
    resetTab: () => void;
}

const initialState: FantasyDiscoverSectionTabState = {
    discoverSectionTab: DiscoverSectionTab.Fresh,
};

export const useFantasyDiscoverSectionTab = create<FantasyDiscoverSectionTab>()(
    devtools(
        (set) => ({
            ...initialState,
            setDiscoverSectionTab: (discoverSectionTab) => set({ discoverSectionTab }),
            resetTab: () => set(initialState),
        }),
        { name: 'fantasy-discover-section-tab-storage' },
    ),
);
